import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import defaultPhotoSrc from '../../assets/images/slide/start-image-memory.png';
import styles from './StartSlideV2.css';

const DEFAULT_HEADING = (
    <>
        {'One day, you’ll call'}
        <br />
        <em>and no one will answer.</em>
    </>
);

const DEFAULT_SUBHEADING = 'Take this 2-minute quiz to personalize your subscription';

function StartSlideV2({
    id,
    imageSrc = defaultPhotoSrc,
    heading = DEFAULT_HEADING,
    subheading = DEFAULT_SUBHEADING,
    ageQuestion,
    onContinue
}) {
    const handleChange = answer => () => {
        logEvent(EVENT_TYPES.QUIZ_START_CLICKED, { label: answer.text });
        onContinue({ ...answer, questionId: ageQuestion.id, question: ageQuestion.question });
    };

    return (
        <div className={styles.form} key={id}>
            <h1 className={styles.heading}>
                {heading}
            </h1>
            <p className={styles.subheading}>{subheading}</p>
            {Boolean(ageQuestion.label) && <p className={styles.ageLabel}>{ageQuestion.label}</p>}
            <div className={styles.ageBlock}>
                <div className={styles.imageWrapper}>
                    <img src={imageSrc} alt='' className={styles.image} />
                </div>
                <ul className={styles.answers}>
                    {ageQuestion.answers.map(answer => (
                        <li key={answer.id} className={styles.answer}>
                            <button
                                type='button'
                                onClick={handleChange(answer)}
                                className={styles.answerButton}
                            >
                                <span className={styles.answerText}>{answer.text}</span>
                                <span className={styles.answerIcon}>
                                    <Icon name='chevronRight' />
                                </span>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

StartSlideV2.propTypes = {
    id: PropTypes.number.isRequired,
    imageSrc: PropTypes.string,
    heading: PropTypes.node,
    subheading: PropTypes.string,
    ageQuestion: PropTypes.shape({
        id: PropTypes.number.isRequired,
        question: PropTypes.string.isRequired,
        label: PropTypes.string,
        answers: PropTypes.array.isRequired
    }).isRequired,
    onContinue: PropTypes.func.isRequired
};

export {
    StartSlideV2
};
